import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { formatDate, toDisplayDecimal } from '../../utils';
import { IsEnglish } from '../../utils/language';
import i18next from 'i18next';
import GoogleMap from 'google-map-react';
import Place from '@material-ui/icons/Place';
import styles from '../../styles/punch.module.css';
import { GetLocalApiKey } from '../../utils/companyConfig';
import { GetABCUsage } from '../../utils/companyConfig';
import * as storage from '../../utils/storage';

const useStyles = makeStyles({
    table: {
        '& td': {
            border: '0px'
        }
    },
    head: {
        lineHeight: '0.5'
    },
    labelSubCode: {
        textAlign: 'right'
    }
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "var(--color1)",
        color: theme.palette.common.white,
        padding: "5px"
    },
    body: {
        fontSize: 14,
    }
}))(TableCell);

const StyledFirstTableCell = withStyles((theme) => ({
    body: {
        fontSize: 14,
        width: '200px',
        '@media (max-width: 600px)': {
            width: "150px"
        },
        fontWeight: "bold"
    },
}))(TableCell);

const StyledCommentTableCell = withStyles((theme) => ({
    body: {
        fontSize: 14,
        width: '200px',
        '@media (max-width: 600px)': {
            width: "150px"
        },
        fontWeight: "bold"
    },
}))(TableCell);

function IsApiSet() {
    if (GetLocalApiKey() != null && GetLocalApiKey() != "undefined") {
        return true;
    } else {
        return false;
    }
};

export default function PunchDetailDisplay(props) {
    const LocationPin = () => <div><Place color="secondary" style={{ fontSize: 30 }} /></div>;

    const classes = useStyles();

    const { data } = props;

    const [useGeolocation, setUseGeolocation] = useState(storage.getUseGeolocation());
    const [dataSubCode, setDataSubCode] = useState([]);

    useEffect(() => {
        resizeForm();
    }, [])

    useEffect(() => {
        if (props.data.punchTime1 != undefined) {
            handleSubCodeList();
        }
    }, [props.data])

    const handleSubCodeList = () => {
        const listSubCode = [];
        for (var i = 0; i < 6; i++) {
            const objSubCode = getTimeSubCode(i + 1);
            if (objSubCode) {
                listSubCode.push(objSubCode);
            }
        }
        if (listSubCode.length > 0) {
            setDataSubCode(listSubCode);
        }
    }

    const getTimeSubCode = (indexSubCode) => {
        const punchTime = props.data[`punchTime${indexSubCode}`];
        if (punchTime && punchTime > 0) {
            const descriptionSubCode = IsEnglish() ? props.data[`subCodeTP${indexSubCode}DescriptionEn`] : props.data[`subCodeTP${indexSubCode}DescriptionFr`];

            return {
                punchTime,
                description: descriptionSubCode
            }
        }

        return null;
    }

    const defaultProps = {
        center: {
            lat: data.latitude,
            lng: data.longitude
        },
        zoom: 11
    };

    const abcUsage = GetABCUsage();

    const HasPosition = () => {
        let hasPosition = true;

        if (data.latitude === 0 || data.longitude === 0) {
            hasPosition = false;
        }

        return hasPosition;
    }

    const resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const offSet = 60;

            const customHeight = height - titleBar - offSet;

            const element = document.querySelector('#divDetailPunch');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 100);
    }

    return (
        <React.Fragment>
            <div id="divDetailPunch" className={styles.detailPunch}>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="spanning table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center" colSpan={2} className={classes.head}>
                                    {formatDate(data.startDate, 'date')}
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('punch:detail.begin')}</StyledFirstTableCell>
                                <TableCell>{formatDate(data.startDate, 'time')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('punch:detail.realBegin')}</StyledFirstTableCell>
                                <TableCell>{formatDate(data.startDate, 'time')}</TableCell>
                            </TableRow>
                            {data.endDate && <TableRow>
                                <StyledFirstTableCell>{i18next.t('punch:detail.end')}</StyledFirstTableCell>
                                <TableCell>{formatDate(data.endDate, 'time')}</TableCell>
                            </TableRow>}
                            {data.realEndDate && <TableRow>
                                <StyledFirstTableCell>{i18next.t('punch:detail.realEnd')}</StyledFirstTableCell>
                                <TableCell>{formatDate(data.realEndDate, 'time')}</TableCell>
                            </TableRow>}
                            {dataSubCode.map((obj, index) =>
                                <TableRow key={index}>
                                    <StyledFirstTableCell>
                                        <div className={classes.labelSubCode}>
                                            {obj.description}
                                        </div>
                                    </StyledFirstTableCell>
                                    <TableCell>{toDisplayDecimal(obj.punchTime, 2)}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="spanning table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center" colSpan={2} className={classes.head}>
                                    {i18next.t('punch:detail.title-information')}
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('punch:detail.department')}</StyledFirstTableCell>
                                <TableCell>{IsEnglish() ? data.departmentEnglish : data.departmentFrench}</TableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('punch:detail.jobTitle')}</StyledFirstTableCell>
                                <TableCell>{IsEnglish() ? data.jobTitleEnglish : data.jobTitleFrench}</TableCell>
                            </TableRow>
                            {(data.projectEnglish !== null || data.projectFrench !== null) && (<TableRow>
                                <StyledFirstTableCell>{i18next.t('punch:detail.project')}</StyledFirstTableCell>
                                <TableCell>{IsEnglish() ? data.projectEnglish : data.projectFrench}</TableCell>
                            </TableRow>)}
                            {(data.activityEnglish !== null || data.activityFrench !== null) && (<TableRow>
                                <StyledFirstTableCell>{i18next.t('punch:detail.activity')}</StyledFirstTableCell>
                                <TableCell>{IsEnglish() ? data.activityEnglish : data.activityFrench}</TableCell>
                            </TableRow>)}
                        </TableBody>
                    </Table>
                </TableContainer>

                {(data.commentStart || data.commentEnd) && <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="spanning table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center" colSpan={2} className={classes.head}>
                                    {i18next.t('punch:detail.title-employee-comment')}
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <StyledCommentTableCell>{i18next.t('punch:detail.punchIn')}</StyledCommentTableCell>
                                <TableCell>{data.commentStart}</TableCell>
                            </TableRow>
                            {data.commentEnd && <TableRow>
                                <StyledCommentTableCell>{i18next.t('punch:detail.punchOut')}</StyledCommentTableCell>
                                <TableCell>{data.commentEnd}</TableCell>
                            </TableRow>}
                        </TableBody>
                    </Table>
                </TableContainer>}

                {useGeolocation && <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="spanning table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center" colSpan={2} className={classes.head}>
                                    {i18next.t('punch:detail.title-geolocation')}
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('punch:detail.address')}</StyledFirstTableCell>
                                <TableCell>{data.address}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>}

                {useGeolocation ?
                    IsApiSet() ?
                        (HasPosition() ?
                            <div style={{ height: '350px', width: '100%' }}>
                                <GoogleMap
                                    bootstrapURLKeys={{ key: GetLocalApiKey() }}
                                    center={defaultProps.center}
                                    zoom={14}
                                >
                                    <LocationPin
                                        lat={data.latitude}
                                        lng={data.longitude}
                                    />
                                </GoogleMap>
                            </div>
                            :
                            <div style={{marginLeft: '10px'}}>{i18next.t('geolocation:message.no-geolocation-punch')}</div>
                        )
                        :
                        <div>{i18next.t('geolocation:message.geolocation-error')}</div>
                    : <div></div>}
            </div>
        </React.Fragment>
    );
}